import React, { useEffect } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
// [redux -- users]

import {
  usersAsValueAndLabelSelectors,
  usersIsLoadingSelector,
} from "../../../modules/users/Selectors";

import { getUsersAction } from "../../../modules/users/Actions";

import {
  InputField,
  FormGroup,
  CheckBox,
  FormSectionTitle,
  Separator,
  SearchableSelect,
  Select,
} from "../../../components/form";

import {
  createCustomerAction,
  updateCustomerAction,
  getCustomerAction,
} from "../../../modules/customers/Actions";

import {
  customersIsLoadingSelector,
  customerByIdSelector,
} from "../../../modules/customers/Selectors";

import Schema from "./customersSchema";
import getLangData from "../../../utils/getLangData";

const options = [
  { value: ["0"], label: "Individual" },
  { value: ["1"], label: "Company" },
];

const companySizeOptions = [
  {
    label: "1-10",
    value: "1-10",
  },
  {
    label: "10-100",
    value: "10-100",
  },
  {
    label: "100-1000",
    value: "100-1000",
  },
  {
    label: "More Than 1000",
    value: "1000+",
  },
];

const CustomersForm = (props) => {
  const { getUsers, mappedUsers, usersIsLoading } = props;

  const {
    getCustomer,
    updateCustomer,
    createCustomer,
    customerId,
    customer,
    customersIsLoading,
  } = props;
  const lang = getLangData().general_words
  useEffect(() => {
    getUsers();
    if (customerId) {
      getCustomer(customerId);
    }
  }, [getCustomer, customerId]);

  return (
    <Formik
      enableReinitialize
      validationSchema={Schema(!customer ? true : false)}
      initialValues={customer ? { ...customer } : Schema().cast()}
      onSubmit={async (values) => {
        const userID = values.userID._id;
        const geolocation = [-2.777434, 53.7222317]

        if (customerId) {
          await updateCustomer(customerId, { ...values, userID, geolocation });
        } else {
          await createCustomer({ ...values, userID, geolocation });
        }
      }}
    >
      {({ handleSubmit, values }) => (
        <FormGroup
          heading={customer ? lang.update_customer : lang.create_custome}
          handleSubmit={handleSubmit}
          isLoading={customersIsLoading}
        >
          <FormSectionTitle>{lang.basic_information} :</FormSectionTitle>
          <SearchableSelect
            isLoading={usersIsLoading}
            options={mappedUsers}
            getItems={getUsers}
            name='userID'
            label={lang.user}
            optionLabel={(option) => `${option.firstName} ${option.lastName}`}
          />
          <InputField label={lang.business_name} name='businessName' />
          <Select
            options={options}
            name='customerType'
            label={lang.customer_type}
            inArray={true}
          />
          <Separator />
          <FormSectionTitle>{lang.company} :</FormSectionTitle>
          <InputField name='yearEstablished' label={lang.year_established} />
          <CheckBox
            name='regCompany'
            label={lang.registered_company}
            subLabel='I have Registered Company.'
          />{" "}
          <InputField label={lang.company_size} name='companySize' />
          {/*           <Select
            options={companySizeOptions}
            name='companySize'
            label='Company Size'
          /> */}
          <Separator />
          <FormSectionTitle>{lang.customer_status}</FormSectionTitle>
          <CheckBox name='verified' label={lang.verified} />
          <CheckBox name='trusted' label={lang.trusted} />
          <CheckBox name='moderated' label={lang.moderated} />
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const customerId = props.match?.params.id;

  return {
    // users
    mappedUsers: usersAsValueAndLabelSelectors(state),
    usersIsLoading: usersIsLoadingSelector(state),

    // customers
    customerId,
    customer: customerByIdSelector(state, customerId),
    customersIsLoading: customersIsLoadingSelector(state),
  };
};

const mapDispatchToProps = {
  // users
  getUsers: getUsersAction,

  // customers
  createCustomer: createCustomerAction,
  updateCustomer: updateCustomerAction,
  getCustomer: getCustomerAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomersForm);
